<div class="pos-picker-before"></div>
<div class="pos-picker-select"></div>
<div class="pos-picker-columns">
  <pos-picker-column [col]="col" (posPickerColChange)="handleColChange($event)"></pos-picker-column>
</div>
<div class="pos-picker-after"></div>
